import Content from '../../content.js';
import EventEmitter from '../../../util/eventEmitter.js';

export default class HashFormView extends Content {
  constructor() {
    super({ listeners: {} });
  }

  get dom() {
    return {
      editButton: '.io-form-action-edit',
      cancelButton: '.io-form-action-cancel',
      submitButton: '.io-form-action-save',
      previewButton: '.io-form-action-preview',
    };
  }

  get events() {
    let events = [];

    events[`click ${this.dom.editButton}`] = '_triggerEnable';
    events[`click ${this.dom.cancelButton}`] = '_triggerDisable';
    events[`click ${this.dom.previewButton}`] = '_openPreview';
    events[`click ${this.dom.submitButton}`] = '_submitEvent';
    return events;
  }

  registerListener(event, callback) {
    this.listeners[event] = callback;
    EventEmitter.on(event, callback);
  }

  onDestroy() {
    Object.entries(this.listeners, (event, callback) =>
      EventEmitter.off(event, callback),
    );
  }

  beforeFilter() {
    this.registerListener('enableHashFormSubmit', () =>
      $(this.dom.submitButton).removeClass('disabled'),
    );
    this.registerListener('disableHashFormSubmit', () =>
      $(this.dom.submitButton).addClass('disabled'),
    );
  }

  _submitEvent(e) {
    EventEmitter.emit('hashFormSubmit', e);
  }

  _openPreview() {
    EventEmitter.emit('openHashFormPreview');
  }

  _triggerEnable() {
    EventEmitter.emit('enableHashForm');
  }

  _triggerDisable() {
    EventEmitter.emit('disableHashForm');
  }
}
